import React, { HTMLAttributes, useEffect, useRef, useState } from 'react';
import { AboutUsTypes } from '../../sections/homePage';
import { isItiOS } from '../../utilities/getMobileOS';
// import { weakKey } from '../../utilities/weakKey';

export interface ICPImage extends HTMLAttributes<HTMLPictureElement> {
  gatsbyImageData?: AboutUsTypes.TGatsbyImageData;
}

export const CPImage = ({
  gatsbyImageData,
  className,
  ...otherProps
}: ICPImage) => {
  if (!gatsbyImageData) {
    return <></>;
  }
  const {
    alt = 'This is an image',
    imgProps,
    sourceProps,
    height = 'auto',
    width = 'auto',
  } = gatsbyImageData;

  const imageRef = useRef<HTMLPictureElement>(null);
  const [imgHeight, setImgHeight] = useState<string | number>(height);
  const [imgWidth, setImgWidth] = useState<string | number>(width);

  useEffect(() => {
    const img = imageRef.current;
    if (img) {
      const { offsetHeight, offsetWidth } = img;
      if (offsetHeight > 0) {
        setImgHeight(offsetHeight);
      }
      if (offsetWidth > 0) {
        setImgWidth(img.offsetWidth);
      }
    }
  }, [imageRef.current]);
  // const generateSources = () => {
  //   if (sourceProps) {
  //     const { sources } = sourceProps;
  //     if (sources && sources.length > 0) {
  //       return sources.map(({ sizes, src, srcSet }, index) => {
  //         return (
  //           <source
  //             key={weakKey({ url: `${index}-${src}` })}
  //             srcSet={srcSet || src}
  //             sizes={sizes}
  //           />
  //         );
  //       });
  //     }
  //   }
  // };

  // Temporary handling iPhone specific.
  const isSSR = typeof window === 'undefined';
  if (!isSSR && window.navigator) {
    const { userAgent, vendor } = window.navigator;
    const isiOS = isItiOS(userAgent || vendor);
    if (isiOS) {
      return (
        <img
          src={imgProps?.src}
          alt={alt}
          className={className}
          loading="lazy"
          height={imgHeight}
          width={'100%'}
          {...otherProps}
        />
      );
    }
  }
  if (sourceProps) {
    const { fallback } = sourceProps;
    const { sizes, src, srcSet } = fallback;
    return (
      <picture className={className} ref={imageRef}>
        {/* {generateSources()} */}
        <source srcSet={srcSet || src} sizes={sizes} />
        <img
          src={src}
          alt={alt}
          className={className}
          loading="lazy"
          height={imgHeight}
          width={imgWidth}
          {...otherProps}
        />
      </picture>
    );
  } else {
    if (imgProps) {
      return (
        <picture className={className} ref={imageRef}>
          <img
            src={imgProps.src}
            alt={alt}
            className={className}
            height={imgHeight}
            width={imgWidth}
            loading="lazy"
            {...otherProps}
          />
        </picture>
      );
    }
    return <></>;
  }
};
